import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { FullPageWrapper } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ProviderPageDoubleOptIn } from 'pages/settings/pages/doubleOptIn/context/doubleOptInContext'
import { DoubleOptInPageStore } from 'pages/settings/pages/doubleOptIn/store/doubleOptInPageStore'
import { DoubleOptInGroups } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInGroups/doubleOptInGroups'
import { DoubleOptInHeader } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInHeader/doubleOptInHeader'
import styles from './styles.module.scss'

const DoubleOptInPageContent = observer(() => {
  return (
    <div className={styles.page}>
      <DoubleOptInHeader />
      <DoubleOptInGroups />
    </div>
  )
})

export const DoubleOptInPage = observer(() => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new DoubleOptInPageStore(entities), [])

  return (
    <FullPageWrapper className={styles.wrap}>
      <ProviderPageDoubleOptIn value={store}>
        <DoubleOptInPageContent />
      </ProviderPageDoubleOptIn>
    </FullPageWrapper>
  )
})
